<template>
  <div>
    <h1>Profiel</h1>

    <Alert :variant="alert.variant" :message="alert.message" v-if="alert.enabled" />

    <form @submit.prevent>

      <div v-if="firebaseUser">
        <div class="form-group row">
          <label for="id" class="col-sm-2 col-form-label">ID</label>
          <div class="col-sm-10">
            <p class="col-form-label">{{ firebaseUser.uid }}</p>
          </div>
        </div>
        <div class="form-group row">
          <label for="member_since" class="col-sm-2 col-form-label">Lid sinds</label>
          <div class="col-sm-10">
            <p class="col-form-label">{{ new Date(firebaseUser.metadata.creationTime).toISOString() }}</p>
          </div>
        </div>
        <div class="form-group row">
          <label for="last_session" class="col-sm-2 col-form-label">Laatste sessie</label>
          <div class="col-sm-10">
            <p class="col-form-label">{{ new Date(firebaseUser.metadata.lastSignInTime).toISOString() }}</p>
          </div>
        </div>
      </div>

      <div v-if="user">
        <div class="form-group row">
          <label for="name" class="col-sm-2 col-form-label">Naam</label>
          <div class="col-sm-10">
            <input class="form-control" type="text" v-model.trim="user.name" v-validate="'required'" name="name" data-vv-as="Naam" id="name">
            <span class="invalid-feedback">{{ errors.first('name') }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label for="email" class="col-sm-2 col-form-label">E-mailadres</label>
          <div class="col-sm-10">
            <input class="form-control" type="text" v-model.trim="user.email" v-validate="'required|email'" name="email" data-vv-as="E-mailadres" id="email">
            <span class="invalid-feedback">{{ errors.first('email') }}</span>
          </div>
        </div>
        <!--<div class="form-group row">-->
        <!--  <label for="country" class="col-sm-2 col-form-label">Land</label>-->
        <!--  <div class="col-sm-10">-->
        <!--    <select class="form-control" v-model.trim="user.country" id="country">-->
        <!--      <option v-for="(country, i) in countries" :key="i" :value="country.Code">{{ country.Name }}</option>-->
        <!--    </select>-->
        <!--  </div>-->
        <!--</div>-->

        <button class="btn btn-primary" @click="patchUser">Opslaan</button>
      </div>

    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'

import Alert from './Alert'

import countries from '@/assets/json/ISO_3166-1_alpha-2.json'

// axios.defaults.withCredentials = true

export default {
  metaInfo: {
    title: 'Profile'
  },
  components: {
    Alert: Alert
  },
  data () {
    return {
      alert: {
        enabled: true,
        variant: '',
        message: ''
      },
      user: {
        name: '',
        email: '',
        country: 'ZZ'
      },
      countries: countries
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getUser()
    })
  },
  methods: {
    getUser: function () {
      axios
        .get(`${process.env.BACKEND_URL}/user`, {
          headers: {
            Authorization: `Bearer ${this.firebaseUser.ra}`
          }
        })
        .then(res => (this.user = res.data))
        .catch(err => console.log(err))
    },
    patchUser: function () {
      axios
        .patch(`${process.env.BACKEND_URL}/user`, this.user, {
          headers: {
            Authorization: `Bearer ${this.firebaseUser.ra}`
          }
        })
        .then(() => {
          this.alert.enabled = true
          this.alert.variant = 'success'
          this.alert.message = 'de gegevens zijn aangepast.'
          setTimeout(() => { this.alert.enabled = false }, 5000)
        })
        .catch(err => {
          console.log(err)
          this.alert.enabled = true
          this.alert.variant = 'danger'
          this.alert.message = 'de gegevens konden niet worden aangepast. Probeer het later nog eens.'
          setTimeout(() => { this.alert.enabled = false }, 5000)
        })
    }
  },
  computed: {
    ...mapState(['firebaseUser'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue